export const selectTheme = (state) => state.theme.theme;
